import dayjs from 'dayjs';
import { useRouter } from 'next/router';

import { PLUS_MEMBERSHIP_EVENT } from '~/domains/plusMembership/constants';
import { usePlusMembershipEvent } from '~/domains/plusMembership/queries';
import { useEffectOnce } from '~/hooks/lifecycle';
import { isBetweenDate } from '~/utils/date';

export const CLOSE_TYPE_FROM = 'home';

const MarketHomeToturial = () => {
  const { data } = usePlusMembershipEvent();
  const router = useRouter();

  useEffectOnce(() => {
    const setupDate = localStorage.getItem(PLUS_MEMBERSHIP_EVENT);
    const baseDate = dayjs(setupDate);
    const endDate = baseDate.add(1, 'day').startOf('day');

    // 플멤위크 대상 = 플멤위크 이벤트 기간 이면서, 멤버십 할인 금액이 있을 경우
    const isTargetUser =
      isBetweenDate(data?.event?.startAt || '', data?.event?.endAt || '') &&
      data?.event?.remainDiscountAmount;

    // 이벤트 대상이면서 최초 진입인 경우 이동
    if (!setupDate && isTargetUser) {
      void router.push(`/event/recommend/bridge`);
    }

    // 마켓 홈에 접속 후, 1일을 넘기고 접근한 경우 이동
    if (
      !isBetweenDate(baseDate.toString(), endDate.toString()) &&
      isTargetUser
    ) {
      void router.push(`/event/recommend/bridge`);
    }
  });

  return null;
};

export default MarketHomeToturial;
